import React from 'react';
import { Ambient } from '../Ambient';
import { Eyebrow, Hairline, Reveal } from '../Reveal';
const PILLARS = [{
  label: 'AI-Native',
  body: 'Built from the ground up around real-time conversational AI.'
}, {
  label: 'Telecom-Ready',
  body: 'Designed to work with existing telecom infrastructure, phone numbers, and communication channels.'
}, {
  label: 'Multi-Vertical',
  body: 'One core technology platform powering multiple consumer and enterprise experiences.'
}];
export function AboutSlide() {
  return <section className="relative h-full w-full" data-id="element-566" data-mp="agmy36w6g00k">
      <Ambient variant="quiet" data-id="element-567" data-mp="oh7fpzqcvpsh" />

      <div className="relative flex h-full flex-col px-[110px] pb-[80px] pt-[84px]" data-id="element-568" data-mp="og5rsuo8r8tc">
        <Reveal delay={0} data-id="element-569" data-mp="jimbzqbwanza">
          <Eyebrow data-id="element-570" data-mp="jidypxbv1gnk">About Vexu AI</Eyebrow>
        </Reveal>

        <Reveal delay={0.08} y={18} data-id="element-571" data-mp="2q796pw55z9jp">
          <h2 className="mt-[34px] max-w-[1240px] text-[44px] font-light leading-[1.28] tracking-[-0.02em] text-slate-500" data-id="element-572" data-mp="2q8arisbzfaem">
            Vexu is an{' '}
            <span className="font-medium text-slate-900" data-id="element-573" data-mp="68u4p7mqlh8z">
              AI conversational technology company
            </span>{' '}
            building intelligent communication experiences across voice, digital
            channels, and commerce.
          </h2>
        </Reveal>

        <div className="mt-[76px] grid grid-cols-3 gap-[64px]" data-id="element-574" data-mp="jz7d1b3jixyu">
          {PILLARS.map((pillar, index) => <Reveal key={pillar.label} delay={0.18 + index * 0.07} data-id="element-575" data-mp="oz24pgv53rky" data-mpi={index}>
              <div className="border-l border-slate-900/[0.10] pl-[26px]" data-id="element-576" data-mp="p0wo2qqrjbmx">
                <span className="block text-[11px] font-semibold tabular-nums tracking-[0.28em] text-vexu-600" data-id="element-577" data-mp="tvsifxjh2b37">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-[16px] text-[27px] font-medium tracking-[-0.02em] text-slate-900" data-id="element-578" data-mp="12xs10ua4xn89">
                  {pillar.label}
                </h3>
                <p className="mt-[12px] max-w-[330px] text-[15px] font-light leading-[1.65] text-slate-500" data-id="element-579" data-mp="34pey9dkmeed6">
                  {pillar.body}
                </p>
              </div>
            </Reveal>)}
        </div>

        <div className="flex-1" data-id="element-580" data-mp="6x50rd3cmxe3" />

        <Reveal delay={0.44} data-id="element-581" data-mp="6y7s1m4l31uj">
          <Hairline data-id="element-582" data-mp="kvmmj59p1ztd" />
          <p className="pt-[34px] text-[35px] font-light leading-[1.3] tracking-[-0.02em] text-slate-400" data-id="element-583" data-mp="kw4o8hf4l68o">
            We don&rsquo;t build individual AI applications.
            <br data-id="element-584" data-mp="uu2cv60wd51t" />
            <span className="font-medium text-slate-900" data-id="element-585" data-mp="utislinry4km">
              We build the technology layer that powers them.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}